import { Expose } from "class-transformer";

export class UpdateClientConditionCodeDto {
  @Expose()
  code: string;

  @Expose()
  days: number;

  @Expose()
  id: string;
}
